<!-- No method types message -->
<div
  class="flex-row align-items-center justify-content-center"
  style="margin: 0 auto; padding: 48px"
  *ngIf="noMethodTypes && !loading"
>
  {{ emptyMessageKey | translate }}
</div>

<!-- Table content wrapper with loading overlay -->
<div
  class="table-wrapper"
  [class.loading]="loading"
  [style.min-height.px]="containerHeight"
  *ngIf="!noMethodTypes"
>
  <!-- Loading overlay - preserves the space while showing loading state -->
  <div class="loading-overlay" *ngIf="loading">
    <div class="loading-content">
      <i class="ri-loader-4-line spin"></i>
      {{ 'info.loading_data' | translate }}
    </div>
  </div>

  <!-- Table content - visible but dimmed during loading -->
  <table
    mat-table
    [dataSource]="items"
    class="spotlab-table"
    matSort
    style="width: 100%"
    [class.dimmed]="loading"
  >
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.name' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let methodType" class="name-cell">
        {{ methodType.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="usedByCaseTypes">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.casetypes' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let methodType" class="count-cell">
        <ts-loading-attribute
          icon="ri-article-line"
          [value]="methodType.usedByCaseTypes"
          class="flex-row align-items-center justify-left"
        ></ts-loading-attribute>
      </td>
    </ng-container>

    <ng-container matColumnDef="usedBySamples">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.samples' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let methodType" class="count-cell last-data-cell">
        <ts-loading-attribute
          icon="ri-flask-line"
          [value]="methodType.usedBySamples"
          class="flex-row align-items-center justify-left"
        ></ts-loading-attribute>
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let methodType" class="icon-cell">
        <button
          class="icon-button"
          type="button"
          (click)="editClicked.emit(methodType); $event.stopPropagation()"
          data-cy="method-type-edit"
        >
          <i class="ri-pencil-line"></i>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let methodType" class="icon-cell">
        <button
          class="icon-button danger"
          type="button"
          (click)="deleteClicked.emit(methodType); $event.stopPropagation()"
          data-cy="method-type-delete"
        >
          <i class="ri-delete-bin-6-line"></i>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="assigned">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let methodType" class="icon-cell">
        <button
          class="icon-button assigned-toggle"
          [class.assigned]="methodType.assigned"
          type="button"
          [matTooltip]="(methodType.assigned ? 'label.unassign' : 'label.assign') | translate"
          [matTooltipShowDelay]="1000"
          (click)="assignedToggled.emit(methodType); $event.stopPropagation()"
          data-cy="method-type-assigned"
        >
          <i [class]="methodType.assigned ? 'ri-checkbox-circle-fill' : 'ri-add-circle-line'"></i>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="visibleColumns"></tr>
    <tr mat-row *matRowDef="let methodType; columns: visibleColumns"></tr>
  </table>
</div>
